<template>
  <v-app>
    <v-content class="white-background">
      <router-view></router-view>
    </v-content>

    <!-- DIALOGS -->
    <error-snackbar ref="errorSnackbar"></error-snackbar>

  </v-app>
</template>

<script>
import themes from '@/js/themes'
import ErrorSnackbar from '@/components/errors/GlobalErrorSnackbar.vue'

export default {
  components: {
    ErrorSnackbar
  },
  methods: {
    setTheme (theme) {
      this.$vuetify.theme.setTheme('light', themes[theme.value].themes.light)
      this.$vuetify.theme.setTheme('dark', themes[theme.value].themes.dark)
      this.$vuetify.theme.dark = theme.dark
    }
  },
  created () {
    var theme = { title: 'Theme 1', value: 'theme1', dark: false }
    this.setTheme(theme)
  },
  mounted () {
    this.$root.$errorSnackbar = this.$refs.errorSnackbar.open
  }
}
</script>

<style scoped lang="scss">
.white-background {
  background: white;
}
</style>

